module.exports = __webpack_public_path__ + "img/privilege-icon.58ef7bee.png";